import { render, staticRenderFns } from "./DesktopGame.vue?vue&type=template&id=dbde8218&scoped=true&"
import script from "./DesktopGame.vue?vue&type=script&lang=js&"
export * from "./DesktopGame.vue?vue&type=script&lang=js&"
import style0 from "./DesktopGame.vue?vue&type=style&index=0&id=dbde8218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbde8218",
  null
  
)

export default component.exports